import React from 'react';
import { Nav, Navbar, NavItem, InputGroup, Modal } from 'react-bootstrap';
import Select from 'react-select';

import axios from 'axios';
import { LinkContainer } from 'react-router-bootstrap';
import constants from '.././util/constants';
import FontAwesome from 'react-fontawesome';
import ReactGA from 'react-ga';
import * as Grants from '.././util/grants';
import { hasGrant } from '.././util/grantHelper';

import './style.scss';
import logoblack from '../../lib/icons/logo-black.png';
import logoblue from '../../lib/icons/logo-blue.png';

const { API_BASE_URL } = constants;

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loggedIn: this.props.apiToken ? true : false,
            adminMenu: false,
            header: this.props.apiToken ? {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            } : {},
            loaded: true,
            user: {},
            userCcr: null,
            agents: [],
            userShort: null,
            showError: false,
            internal: false,
            customer: null,
            customers: [],
            mac: null,
            macs: [],
            denyFilter: false,
            isCustomer: false,
            showDiagnostics: false,
            diagnosticsData: null
        };
        this.openDiagnostics = this.openDiagnostics.bind(this);
        this.closeDiagnostics = this.closeDiagnostics.bind(this);
        this.changeUser = this.changeUser.bind(this);
        this.getAgents = this.getAgents.bind(this);
        this.getActiveUser = this.getActiveUser.bind(this);
        this.getMarketAreaCodes = this.getMarketAreaCodes.bind(this);
        this.clearState = this.clearState.bind(this);
        this.changeCustomerFilter = this.changeCustomerFilter.bind(this);
        this.changeMarketFilter = this.changeMarketFilter.bind(this);
        this.getCustomerCodes = this.getCustomerCodes.bind(this);
        this.prependToList = this.prependToList.bind(this);
        this.refreshData = this.refreshData.bind(this);
        // document.addEventListener('mousedown', this.handleClick, false);
    }

    componentDidMount() {
        if (this.props.apiToken) {
            this.getActiveUser(this.props.apiToken);
        }
    }
    // componentWillUnmount() {
    //     document.removeEventListener('mousedown', this.handleClick, false);
    // }


    // handleClick = (e) => {
    //     if (this.node && this.node.contains(e.target)) {
    //         return;
    //     }
    //     this.setState({ adminMenu: false })
    // }

    clearState() {
        window.sessionStorage.setItem('Grants', JSON.stringify([]));
        window.sessionStorage.setItem('UserType', 0);
        window.sessionStorage.setItem('LegalEntity', 'None');

        this.setState({
            loggedIn: false,
            adminMenu: false,
            header: {},
            loaded: true,
            user: {},
            userCcr: null,
            agents: [],
            userShort: null,
            showError: false,
            internal: false,
            customer: null,
            customers: [],
            mac: null,
            macs: [],
            denyFilter: false,
            isCustomer: false
        });
    }

    refreshData() {
        if (this.state.user.Settings.UserType === 1) {
            if (this.state.mac == null && this.state.customer == null)
                this.setState({ denyFilter: true });
            else
                this.setState({ denyFilter: false });
        }
        else
            this.setState({ denyFilter: false });
        this.props.refreshPage();
    }

    prependToList(list, type) {
        if (this.state.user.Settings.UserType === 3)
            return list;

        let item = {};
        if (this.state.user.Settings.UserType === 1) {
            item = { label: 'Select ' + type, value: '' }
        }
        else {
            item = { label: 'Select ' + type, value: this.state.userCcr }
        }
        list = [item, ...list];
        return list;
    }

    getCustomerCodes(headers) {
        if (this.state.user && this.state.user.Settings.UserType === 3) {
            return;
        }
        let self = this;
        if (!headers) {
            headers = this.state.header;
        }
        axios.get(API_BASE_URL + 'Filter/GetCustomerFilter', { headers: headers })
            .then(result => {
                let list = result.data.map(x => {
                    return { label: x.Label, value: x.Value }
                }).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));

                list = self.prependToList(list, 'Customer');

                self.setState({ loaded: true, customers: list });
            }).catch(() => {
                self.setState({ loaded: true, showError: true })
            });
    }

    getMarketAreaCodes(headers) {
        let self = this;
        axios.get(API_BASE_URL + 'Filter/GetMarketFilter', { headers: headers })
            .then(result => {
                let list = result.data.map(x => {
                    return { label: x.Label, value: x.Value }
                }).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));

                list = self.prependToList(list, 'Market Area');

                self.setState({ loaded: true, macs: list });
            }).catch(() => {
                self.setState({ loaded: true, showError: true })
            });
    }

    getActiveUser(header) {
        this.setState({ loaded: false });
        let self = this;
        let headers = header ? {
            'Authorization': 'Bearer ' + header,
            'Accept': 'application/octet-stream'
        } : {}
        axios.get(API_BASE_URL + 'Filter/GetUser', { headers: headers })
            .then(result => {
                self.setState({ loaded: true, user: result.data });
                window.sessionStorage.setItem('Grants', JSON.stringify(result.data.Grants.map(x=>x.Type)));
                window.sessionStorage.setItem('UserType', result.data.Settings.UserType);
                window.sessionStorage.setItem('LegalEntity', result.data.Settings.LegalEntity);
                window.sessionStorage.setItem('UnitConversion', result.data.Settings.UnitConversion);
                
                if (result.data.Settings.UserType === 1) {
                    self.setState({
                        mac: result.data.Settings.MarketAreaCodeFilter ? [{ value: result.data.Settings.MarketAreaCodeFilter }] : null,
                        userCcr: result.data.Email ? [{ value: result.data.Email }] : null,
                        customer: result.data.Settings.CustomerFilter ? [{ value: result.data.Settings.CustomerFilter }] : null,
                        internal: true
                    });
                }
                else if (result.data.Settings.UserType === 2) {
                    self.setState({
                        userCcr: result.data.Settings.AgentFilter ? [{ value: result.data.Settings.AgentFilter }] : null,
                        customer: result.data.Settings.CustomerFilter ? [{ value: result.data.Settings.CustomerFilter }] : null
                    });
                }
                else {
                    self.setState({
                        userCcr: result.data.Settings.AgentFilter ? [{ value: result.data.Settings.AgentFilter }] : null,
                        customer: result.data.Settings.CustomerFilter ? [{ value: result.data.Settings.CustomerFilter }] : null,
                        isCustomer: true
                    });
                }
                if (result.data.Settings) {
                    if (result.data.Settings.UserType === 1) {
                        if (result.data.Settings.MarketAreaCodeFilter == null && result.data.Settings.CustomerFilter == null)
                            self.setState({ denyFilter: true });
                        self.getMarketAreaCodes(headers);
                    }
                    self.getAgents(headers);
                    if (result.data.Settings.UserType !== 3) {
                        self.getCustomerCodes(headers);
                    }
                }
            }).catch((error) => {
                // If the token is expired or invalid (e.g. after a new release), the backend returns 401.
                // Clear the token so the user is redirected to the login screen.
                if (error.response && error.response.status === 401) {
                    const { setApiToken } = self.props;
                    if (setApiToken) {
                        setApiToken(null);
                        return;
                    }
                }
                self.setState({ loaded: true, showError: true })
            });
    }

    getAgents(headers) {
        let self = this;
        axios.get(API_BASE_URL + 'Filter/GetUserFilter', { headers: headers })
            .then(result => {
                self.setState({
                    loaded: true, agents: result.data.map(x => {
                        return { label: x.Label, value: x.Value }
                    }).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }))
                });
            }).catch(() => {
                self.setState({ loaded: true, showError: true })
            });
    }

    changeUser(item) {
        let self = this;
        axios.get(API_BASE_URL + `Filter/ChangeUserFilter/?clientCode=${item?.value}`, { headers: this.state.header })
            .then(result => {
                // window.sessionStorage.setItem('Grants', JSON.stringify(result.data.Grants)); // Tror inte den behövs här -- Kan behövas för att slå igenom i UI't
                window.sessionStorage.setItem('LegalEntity', result.data.Settings.LegalEntity);
                window.sessionStorage.setItem('Grants', JSON.stringify(result.data.Grants.map(x=>x.Type)));
                self.setState({
                    loaded: true,
                    userCcr: item,
                    customer: result.data.Settings.AgentFilter,
                    customers: null
                });
                self.getCustomerCodes();
                self.props.refreshPage();
            }).catch(() => {
                self.setState({ loaded: true, showError: true })
            });
    }

    changeCustomerFilter(item) {
        let self = this;
        axios.get(API_BASE_URL + `Filter/ChangeCustomerFilter/?clientCode=${item?.value}`, { headers: this.state.header })
            .then(result => {
                self.setState({ loaded: true, customer: item });
                self.refreshData();
            }).catch(() => {
                self.setState({ loaded: true, showError: true })
            });
    }

    changeMarketFilter(item) {
        let self = this;
        axios.get(API_BASE_URL + `Filter/ChangeMarketFilter/?clientCode=${item?.value}`, { headers: this.state.header })
            .then(result => {
                self.setState({ loaded: true, mac: item, customer: null, customers: null });
                self.getCustomerCodes();
                self.refreshData();
            }).catch(() => {
                self.setState({ loaded: true, showError: true })
            });
    }

    getCombo(_caption, _stateObj, _onChange, _placeHolder, _options, _clearable = true, disabled = false) {

        // userCCr value is set wrongly for the new react-select, since the value needs to be of
        // type [{ label: '', value: '' }], and not just string (previusly just email (value)).
        let value = this.state[_stateObj] || '';
        if (value && !value.label)
            getCorrectLabelFromValue(value)

        function getCorrectLabelFromValue(value) {
            let result = value[0];
            if (result == null) return false;
            if (typeof result != 'object') return false;
            result = _options.find(a => a.value == result.value);
            value[0].label = result?.label;
        }

        return (
            <InputGroup className="margin-left-5 margin-top-3" bsSize="sm">
                <Select isSearchable={true} isClearable={_clearable}
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            minHeight: '25px',
                            height: '25px'
                        }),
                        valueContainer: (provided) => ({
                            ...provided,
                            height: '25px',
                            minWidth: '150px'
                        }),
                        indicatorsContainer: (provided) => ({
                            ...provided,
                            height: '25px',
                        }),
                    }}
                    isDisabled={disabled}
                    onChange={(item) => _onChange(item, _stateObj)}
                    value={this.state[_stateObj] || ''}
                    options={_options} placeholder={_placeHolder} />
            </InputGroup>
        );
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.apiToken !== nextProps.apiToken && nextProps.apiToken != null) {
            this.setState({
                loggedIn: nextProps.apiToken ? true : false,
                header: nextProps.apiToken ? {
                    'Authorization': 'Bearer ' + nextProps.apiToken,
                    'Accept': 'application/octet-stream'
                } : {},
            });
            let header = nextProps.apiToken;
            this.getActiveUser(header);
        }

        else if (nextProps.refreshHeader && nextProps.apiToken != null) {
            this.clearState();
            this.setState({
                loggedIn: nextProps.apiToken ? true : false,
                header: nextProps.apiToken ? {
                    'Authorization': 'Bearer ' + nextProps.apiToken,
                    'Accept': 'application/octet-stream'
                } : {},
            });
            let header = nextProps.apiToken;
            this.getActiveUser(header);
        }
    }

    openDiagnostics() {
        axios.get(API_BASE_URL + 'Portal/GetConnectionStringDiagnostics', { headers: this.state.header })
            .then(result => {
                this.setState({ showDiagnostics: true, diagnosticsData: result.data });
            }).catch(() => {
                this.setState({ showDiagnostics: true, diagnosticsData: null });
            });
    }

    closeDiagnostics() {
        this.setState({ showDiagnostics: false, diagnosticsData: null });
    }

    GAtrackHandler(e) {

        ReactGA.event({
            category: "Navigation",
            action: e.target.innerText,
        });
    }


    render() {
        const { loggedIn, internal, user, denyFilter, isCustomer } = this.state;
        const classes = this.state.adminMenu ? 'toggle' : 'toggle closed'
        const { setApiToken } = this.props;
        const dropdown = this.state.agents && this.state.agents.length < 2;
        const customer = this.state.user && this.state.user.Settings && this.state.user.Settings.UserType === 3 ? true : false;
        let env;

        if (process.env.REACT_APP_CURRENT_DEPLOYMENT_ENV !== "" && process.env.REACT_APP_CURRENT_DEPLOYMENT_ENV !== "Production") {
            env = <p className="navenv">{process.env.REACT_APP_CURRENT_DEPLOYMENT_ENV}</p>;
        }

        return (<Navbar collapseOnSelect fixedTop fluid>
            <Navbar.Header>

                {loggedIn && user && hasGrant(Grants.TYPES.Admin_ViewAdministrationMenu) &&
                    <div id="adminIcon" className="flex-column left" onClick={() => { this.setState({ adminMenu: true }) }}>
                        <img src={logoblue} alt="icon" height="18" width="18" />
                    </div>
                }

                {loggedIn && user && hasGrant(Grants.TYPES.Admin_ViewAdministrationMenu) &&
                    <div id="adminMenu" className={classes} ref={node => this.node = node}>
                        <nav>
                            <div id="adminIconOpen" className="flex-column left" onClick={() => { this.setState({ adminMenu: false }) }}>
                                <img src={logoblack} alt="icon" height="18" width="18" />
                            </div>
                        </nav>
                        <label>Administration</label>
                        <ul>
                            {hasGrant(Grants.TYPES.Admin_ViewUserList) && 
                            <LinkContainer to="/admin">
                                <NavItem onClick={() => { this.setState({ adminMenu: false }) }}>Manage users</NavItem>
                            </LinkContainer>
                            }
                            {hasGrant(Grants.TYPES.Admin_CreateRoles) && 
                            <LinkContainer to="/admin/roles">
                                <NavItem onClick={() => { this.setState({ adminMenu: false }) }}>Manage roles</NavItem>
                            </LinkContainer>
                            }
                            {hasGrant(Grants.TYPES.Admin_EditGlobalSettings) && 
                            <LinkContainer to="/admin/globalsettings">
                                <NavItem onClick={() => { this.setState({ adminMenu: false }) }}>Global settings</NavItem>
                            </LinkContainer>
                            }
                            {hasGrant(Grants.TYPES.Admin_ViewCapacityAllocation) && 
                            <LinkContainer to="/admin/capacity">
                                <NavItem onClick={() => { this.setState({ adminMenu: false }) }}>View and edit Capacity</NavItem>
                            </LinkContainer>
                            }
                            {hasGrant(Grants.TYPES.Admin_ViewCapacityAllocation) &&
                                <LinkContainer to="/admin/productioncycle">
                                    <NavItem onClick={() => {this.setState({adminMenu: false})}}>Production cycles</NavItem>
                                </LinkContainer>
                            }
                            {hasGrant(Grants.TYPES.News_CreateNews) && 
                            <LinkContainer to="/admin/news">
                                <NavItem onClick={() => { this.setState({ adminMenu: false }) }}>Create and edit news</NavItem>
                            </LinkContainer>
                            }
                        </ul>
                    </div>
                }
                {env}
                <Navbar.Brand>
                    <LinkContainer to="/">
                        <a className="navbar-brand">Nordic Paper</a>
                    </LinkContainer>
                </Navbar.Brand>

                <Navbar.Toggle />
            </Navbar.Header>

            <Navbar.Collapse>
                <Nav>
                    {!loggedIn &&
                        <LinkContainer to="/login">
                            <NavItem onClick={(e) => { this.GAtrackHandler(e); this.setState({ adminMenu: false }) }}>Login</NavItem>
                        </LinkContainer>}

                    {loggedIn &&
                        <LinkContainer to="/dashboard">
                            <NavItem onClick={(e) => { this.GAtrackHandler(e); this.setState({ adminMenu: false }) }}>Dashboard</NavItem>
                        </LinkContainer>}

                    {loggedIn && hasGrant(Grants.TYPES.News_SeeNews) &&
                        <LinkContainer to="/news">
                            <NavItem onClick={(e) => { this.GAtrackHandler(e); this.setState({ adminMenu: false }) }}>News</NavItem>
                        </LinkContainer>}

                    {loggedIn && hasGrant(Grants.TYPES.Order_ViewOrderInformation) &&
                        <LinkContainer to="/ordersearch">
                            <NavItem onClick={(e) => { this.GAtrackHandler(e); this.setState({ adminMenu: false }) }}>Orders</NavItem>
                        </LinkContainer>}
                    {loggedIn && hasGrant(Grants.TYPES.Stock_ViewStock) &&
                        <LinkContainer to="/stocksearch">
                            <NavItem onClick={(e) => { this.GAtrackHandler(e); this.setState({ adminMenu: false }) }}>Stock</NavItem>
                        </LinkContainer>}
                    {loggedIn && hasGrant(Grants.TYPES.CustomerProfile_ViewCustomerProfile) &&
                        <LinkContainer to="/customerprofile">
                            <NavItem onClick={(e) => { this.GAtrackHandler(e); this.setState({ adminMenu: false }) }}>Customer Profile</NavItem>
                        </LinkContainer>}
                    {loggedIn && hasGrant(Grants.TYPES.Allocation_ViewAllocation) &&
                        <LinkContainer to="/allocation">
                            <NavItem onClick={(e) => { this.GAtrackHandler(e); this.setState({ adminMenu: false }) }}>Allocation</NavItem>
                        </LinkContainer>}
                    {loggedIn && hasGrant(Grants.TYPES.Document_SeeDocuments) &&
                    <LinkContainer to="/documents">
                        <NavItem onClick={(e) => { this.GAtrackHandler(e); this.setState({ adminMenu: false }) }}>Documents</NavItem>
                    </LinkContainer>}
                </Nav>


                {loggedIn &&
                    <Nav pullRight>
                        {hasGrant(Grants.TYPES.General_ViewProfile) &&
                            <LinkContainer to="/profile">
                                <NavItem>
                                    <FontAwesome name="user-circle-o" className="bigger" />
                                </NavItem>
                            </LinkContainer>
                        }
                        {internal &&
                            <NavItem onClick={this.openDiagnostics}>
                                <FontAwesome name="info-circle" className="bigger" />
                            </NavItem>
                        }
                        <LinkContainer to="/login">
                            <NavItem onClick={() => { setApiToken(null); this.clearState() }}>
                                <FontAwesome name="sign-out" className="bigger" />
                            </NavItem>
                        </LinkContainer>
                    </Nav>}

                <Modal show={this.state.showDiagnostics} onHide={this.closeDiagnostics}>
                    <Modal.Header closeButton>
                        <Modal.Title>Connection Diagnostics</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.diagnosticsData
                            ? <table className="table table-condensed">
                                <tbody>
                                    {Object.entries(this.state.diagnosticsData).map(([key, value]) => (
                                        <tr key={key}>
                                            <td><strong>{key}</strong></td>
                                            <td>{value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                              </table>
                            : <p>No data available.</p>
                        }
                    </Modal.Body>
                </Modal>
                {loggedIn &&
                    <div className="pull-right top-filter">
                        {isCustomer == false &&
                            <div className={denyFilter ? "pull-left error" : "pull-left"}>
                                {this.getCombo('Customer', "customer", this.changeCustomerFilter, 'Select Customer', this.state.customers, true, customer)}
                            </div>
                        }
                        {internal &&
                            <div className={denyFilter ? "pull-left error" : "pull-left"}>
                                {this.getCombo('Market area code', "mac", this.changeMarketFilter, 'Select Market Area', this.state.macs, true)}
                            </div>
                        }
                        <div className="pull-left">
                            {this.getCombo('User', "userCcr", this.changeUser, 'User', this.state.agents, false, dropdown)}
                        </div>
                    </div>
                }

            </Navbar.Collapse>
        </Navbar>);
    }
}

export default Header;